module.exports = __webpack_public_path__ + "4ff2b9f766ec6a9bdb8d5583666ac17f.jpg";